(function () {
  if (customElements.get('color-swatches')) return;

  // Name of the real, native Shopify storefront filter these swatches drive.
  // This is the same "Colour" filter that already appears in the collection's
  // filter sidebar (backed by the product.metafields.custom.colour metafield),
  // so clicking a swatch just checks/unchecks that filter's checkbox and lets
  // the theme's own filtering JS do the (correctly paginated, AJAX) product
  // grid update - no custom DOM hiding, no pagination bugs.
  const FILTER_NAME = 'filter.p.m.custom.colour';

  function findFilterInput(value) {
    return document.querySelector(
      'input[name="' + FILTER_NAME + '"][value="' + CSS.escape(value) + '"]'
    );
  }

  class ColorSwatches extends HTMLElement {
    connectedCallback() {
      this.buttons = Array.from(this.querySelectorAll('[data-swatch-value]'));
      this.clearBtn = this.querySelector('[data-swatch-clear]');

      this.buttons.forEach((btn) => {
        btn.addEventListener('click', () => this.toggle(btn.dataset.swatchValue));
      });

      if (this.clearBtn) {
        this.clearBtn.addEventListener('click', () => this.clearAll());
      }

      // The sidebar filter form gets replaced wholesale after every AJAX
      // filter update, so we delegate at the document level rather than
      // binding to specific checkbox nodes (which won't survive that swap).
      document.addEventListener('change', (event) => {
        if (event.target && event.target.name === FILTER_NAME) {
          this.syncActiveState();
        }
      });

      // The theme replaces the whole filter/product-grid area via the
      // Section Rendering API; once that swap lands the new checkboxes'
      // checked state (reflected from the URL) may differ from what we
      // last knew, so resync whenever that happens too.
      const grid = document.querySelector('#filter-results') || document.querySelector('main');
      if (grid && 'MutationObserver' in window) {
        const observer = new MutationObserver(() => this.syncActiveState());
        observer.observe(grid, { childList: true, subtree: false });
      }

      this.syncActiveState();
    }

    toggle(value) {
      const input = findFilterInput(value);

      if (!input) {
        // No product in the *current* filter results has this colour
        // (e.g. combined with another active filter) - nothing to toggle.
        return;
      }

      input.click();
      // A programmatic click on a checkbox toggles `checked` synchronously,
      // so we can reflect the new state immediately without waiting for the
      // theme's AJAX update to finish.
      this.syncActiveState();
    }

    clearAll() {
      const checked = document.querySelectorAll('input[name="' + FILTER_NAME + '"]:checked');
      checked.forEach((input) => input.click());
      this.syncActiveState();
    }

    syncActiveState() {
      let anyActive = false;

      this.buttons.forEach((btn) => {
        const input = findFilterInput(btn.dataset.swatchValue);
        const isActive = !!(input && input.checked);
        if (isActive) anyActive = true;
        btn.parentElement.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', String(isActive));
      });

      if (this.clearBtn) this.clearBtn.hidden = !anyActive;
    }
  }

  customElements.define('color-swatches', ColorSwatches);
})();
